// extracted by mini-css-extract-plugin
module.exports = {"cameraToggle":"styles_cameraToggle__3F7w-"};